define('core/logger',['require','ns'],function (require) {
	'use strict';
	
	var ns = require('ns');

	var _logLevel = null;

	var _getIntValue = function (level) {

		return ns.constant.get('LOGGER:' + level);
	};

	var _writeLog = function (level, args) {

		var levelIntValue = _getIntValue(level);
		var callerName = args[0];
		var logData = args[1];

		if (args.length < 2) {

			logData = callerName;
			callerName = '';
		}

		if (typeof logData === 'object') {

			logData = JSON.stringify(logData);
		}

		if (!_.isEmpty(callerName)) {

			logData = '<' + callerName + '> ' + logData;
		}

		if (window.console && _logLevel <= levelIntValue) {

			if (levelIntValue === _getIntValue('DEBUG')) {

				// [Elvis Chan]: IE8 NOT support console.debug
				if (typeof console.debug === 'undefined') {

					console.log(logData);

				} else {

					console.debug(logData);
				}
			
			} else if (levelIntValue === _getIntValue('INFO')) {

				console.info(logData);
			
			} else if (levelIntValue === _getIntValue('ERROR')) {

				console.error(logData);

			} else if (levelIntValue === _getIntValue('FATAL')) {

				console.error(logData);
			}
		}
	};

	var Logger = function () {

		var isDebug = ns.config.get('debug') || false;

		var level = isDebug ? 'DEBUG' : 'INFO';

		_logLevel = _getIntValue(level);
	};

	Logger.prototype = {

		debug: function () {

			_writeLog('DEBUG', arguments);
		},

		error: function () {

			_writeLog('ERROR', arguments);
		},

		info: function () {

			_writeLog('INFO', arguments);
		},

		warn: function () {

			_writeLog('WARN', arguments);
		}
	};

	return Logger;
});
